import { SyllabusStateType, ActionTypes } from './types';
import { SyllabusInitialState } from './state';
import { normalize } from 'normalizr';
import * as schema from '../../utils/schema';

export default function syllabus(state: SyllabusStateType = SyllabusInitialState, action: any) {

  switch (action.type) {
    case ActionTypes.FETCH_CHAPTER_SYLLABUS:
      const chapters = normalize(action.payload, [schema.chapterSyllabus]);
      return {
        ...state,
        chapters: chapters.entities.chapters
      };

    case ActionTypes.FETCH_COURSE_SYLLABUS:
      const course = normalize(action.payload.coursesDto, [schema.courseSyllabus]);
      const program = { ...action.payload };
      delete program.coursesDto;
      return {
        ...state,
        program,
        courses: course.entities.courses
      };

    case ActionTypes.FETCH_MODULE_SYLLABUS:
      const module = normalize(action.payload, [schema.moduleSyllabus]);

      return {
        ...state,
        modules: module.entities.modules
      };

    default:
      return { ...state };
  }
}